export interface GoogleAdWordsProductAndServiceGq {
  id: number;
  name: string;
}

export const GoogleAdWordsProductAndServiceGqProps = `
  id
  name
`;
